import './StakeholdersTable.scss';

import { DeleteStakeholderNotifications } from './DeleteStakeholderNotifications';
import { getColumns } from './StakeholdersTableColumns';
import { MESSAGES_COPY } from '@sonar-software/sonar-ts-constants';
import { noop } from '@lib/utility';
import { PaginatedResource } from '@sonar-software/sonar-ts-types';
import { PaginatedTable } from '@ui/tables';

import { coreActions, Stakeholder } from '@sonar-software/sonar-core';
import React, { useCallback, useMemo } from 'react';
import { useAction, useAsyncState, useOnMount, useStakeholders } from '@hooks';

const columns = getColumns();
const getRowKey = (stakeholder: Stakeholder) => stakeholder.stakeholderId;

export const StakeholdersTable: React.FC = () => {
	const { data, isRequested } = useAsyncState(useStakeholders.selectors);

	const loadStakeholders = useAction(coreActions.requestGetCoreStakeholders);
	const deleteStakeholder = useAction(coreActions.requestDeleteCoreStakeholders);

	useOnMount(() => {
		loadStakeholders();
	});

	const resource: PaginatedResource<Stakeholder> | undefined = useMemo(() => {
		if (!data) {
			return undefined;
		}

		const stakeholders = data.filter((record) => !record.userId);

		return {
			results: stakeholders,
			totalCount: stakeholders?.length
		};
	}, [ data ]);

	const handleDelete = useCallback(
		(stakeholder: Stakeholder) => {
			deleteStakeholder({
				stakeholderIds: [ stakeholder.stakeholderId ]
			});
		},
		[ deleteStakeholder ]
	);

	return (
		<>
			<PaginatedTable
				columns={ columns }
				deletePrompt={ MESSAGES_COPY.ARE_YOU_SURE_STAKEHOLDER }
				headerSize='small'
				id='stakeholders-table'
				loading={ isRequested }
				onChange={ noop }
				onDelete={ handleDelete }
				resource={ resource }
				rowKey={ getRowKey }
				scroll={ { x: 'max-content' } }
				sticky />
			<DeleteStakeholderNotifications />
		</>
	);
};
